/* eslint-disable react/prop-types */

import { Children, FC, isValidElement, ReactElement, ReactNode } from 'react'

interface ShowProps {
    children: ReactNode
}

type ShowComponent = FC<ShowProps> & {
    When: FC<{ isTrue: boolean; children: ReactNode }>
    Else: FC<{ render?: ReactNode; children: ReactNode }>
}

export const Show: ShowComponent = (props) => {
    const whenChildren: ReactElement[] = []
    let otherwise: ReactElement | null = null
    Children.forEach(props.children, (child) => {
        if (isValidElement(child)) {
            if (child.props.isTrue) {
                whenChildren.push(child)
            } else if (child.type === Show.Else && otherwise === null) {
                otherwise = child
            }
        }
    })
    return whenChildren.length > 0 ? <>{whenChildren}</> : otherwise
}

Show.When = ({ isTrue, children }) =>
    (isTrue ? <>{children}</> : null) as ReactElement | null
Show.Else = ({ render, children }) =>
    (render || children) as ReactElement | null
